import React from 'react';
import PropTypes from 'prop-types';
import {Grid, Icon} from 'tabler-react';
import { Link } from 'react-router-dom';
import './index.sass';

const propTypes = {
    iconPrefix: PropTypes.string,
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    href: PropTypes.string,
    size: PropTypes.number,
    target: PropTypes.string
};

const defaultProps = {
    iconPrefix: 'fe',
    href: '#',
    size: 3,
    target: '_parent'
};

const isExternalUrl = (toLocation) => {
    if (toLocation.startsWith("http") || toLocation.startsWith("//")) {
        return true;
    } 
    
    return false;
}

const FeaturedButton = (props) => {
    return (
        <Grid.Col
            width={props.size}
        >
        {isExternalUrl(props.href) ?
            <a href={props.href} target={props.target} className="featured-button">
                <Icon prefix={props.iconPrefix} name={props.icon} />
            {props.title}
            </a>
            :
            <Link to={props.href} target={props.target} className="featured-button">
                <Icon prefix={props.iconPrefix} name={props.icon} />
                {props.title}
            </Link>
        }
        </Grid.Col>
    );
};

FeaturedButton.propTypes = propTypes;
FeaturedButton.defaultProps = defaultProps;

export default FeaturedButton;